import type { TickRendererProps } from '@visx/axis';
import type { CSSProperties } from 'react';

import Typography from '@dynatrace/strato-design-tokens/typography';

import {
  TICK_LINE_HEIGHT,
  Y_AXES_TICK_LINE_OFFSET,
} from '../../../../core/components/axes/constants.js';

const SMALL_GAP_OFFSET = 1;
const START_ANCHOR_OFFSET = 3;

export function useYTickOffset(
  position: string,
  textWidth: number,
  renderProps: TickRendererProps,
  centerTick: boolean,
) {
  /**
   * The width to be used by containers in order to make the truncation works.
   * The value should be rounded to avoid a premature truncation in Safari that
   * consider a fractional pixel to truncate.
   **/
  const WIDTH = Math.ceil(textWidth);

  const yOffset = centerTick
    ? TICK_LINE_HEIGHT / 2 + SMALL_GAP_OFFSET
    : renderProps.verticalAnchor === 'start'
    ? START_ANCHOR_OFFSET
    : renderProps.verticalAnchor === 'end'
    ? TICK_LINE_HEIGHT - SMALL_GAP_OFFSET
    : TICK_LINE_HEIGHT / 2 + SMALL_GAP_OFFSET;

  const xOffset =
    position === 'left'
      ? textWidth + Y_AXES_TICK_LINE_OFFSET - SMALL_GAP_OFFSET
      : -Y_AXES_TICK_LINE_OFFSET + SMALL_GAP_OFFSET;

  const { x, y, ...restProps } = renderProps;

  const style: CSSProperties = {
    ...(restProps as CSSProperties),
    textAlign: position === 'left' ? 'end' : 'start',
    lineHeight: Typography.Text.Base.Default.LineHeight,
    width: WIDTH,
    height: TICK_LINE_HEIGHT,
    overflow: 'visible',
  };
  return { xOffset, yOffset, style };
}
